import { createContext } from 'react';
export var ApplicationContext = createContext(null);
//# sourceMappingURL=context.js.map